import React, { Component } from 'react';
import { Table, Row, Button, Spin, } from 'antd';
import Auth from "../Auth";
import TableText from "@/bp-views/table/TableText";
import { inject, observer } from "mobx-react";
import FileSaver from "file-saver";
import { getJson, } from '@/method';
import { intervalData } from './data';
import "./index.scss";
import { toJS } from 'mobx';

const TOTALINDEX = [0, 1, 2, 3];

@inject('store')
@observer
class index extends Component {

    onExpoetExcel = () => {
        const name = `1.1.2 Actual ${this.props.store.effectActual.date} 年实际坪效`;
        const innerHtml = `
              <caption>${name}</caption>
              ${document.getElementById('table2').innerHTML.replace(/<table class="">/g, '<table border="1">')}
            `;

        var html = "<html><head><meta charset='utf-8' /></head><body>" + innerHtml + "</body></html>";
        var blob = new Blob([html], { type: "application/vnd.ms-excel" });
        FileSaver.saveAs(blob, `${name}.xls`);
    }

    render() {
        const { budget, date, dataAll, loading, } = this.props.store.effectActual;

        const columns = [{
            dataIndex: 'name',
            key: 'name',
            align: "center",
            width: 300,
            render: (text, record, index) => {

                const props = { text, index: index > 4 ? index - 1 : index, type: 'text', name: "name", totalIndex: TOTALINDEX };
                if (index === 4) {
                    return {
                        children: <TableText data={{
                            ...props, type: "textcenter"
                        }} />,
                        props: {
                            colSpan: 4
                        }
                    }
                }
                return <TableText data={{ ...props }} />
            }
        }, {
            title: <div>Average Area Performance Data<br /> 区域平均数据 <br /> {getJson(['hotel', 'area'], dataAll, "")}</div>,
            dataIndex: 'area',
            key: 'area',
            align: "center",
            width: 200,
            render: (text, record, index) => {
                if (index === 4) {
                    return {
                        props: {
                            colSpan: 0
                        }
                    }
                }
                const props = {
                    text, index: index > 4 ? index - 1 : index, type: 'number', name: "area",
                    compared: {
                        title: ['Average Area Performance Data<br /> 区域平均数据'],
                        record,
                        sqlName: "effect_budget"
                    }, totalIndex: TOTALINDEX
                };

                return <TableText data={{ ...props }} />
            }
        },
        {
            title: <div>Revenue Range (RMB) <br /> 收入区间 （单位：元）<br />{intervalData[getJson(['hotel', 'income_interval'], dataAll, "")]}</div>,
            dataIndex: 'interval',
            key: 'interval',
            align: "center",
            width: 200,
            render: (text, record, index) => {
                if (index === 4) {
                    return {
                        props: {
                            colSpan: 0
                        }
                    }
                }
                const props = {
                    text, index: index > 4 ? index - 1 : index, type: 'number', name: "interval",
                    compared: {
                        title: ['Revenue Range (RMB) <br /> 收入区间 （单位：元）'],
                        record,
                        sqlName: "effect_budget"
                    }, totalIndex: TOTALINDEX
                };

                return <TableText data={{ ...props }} />
            }
        },
        {
            title: <div>Hotel Performance Data<br /> 本酒店数据</div>,
            dataIndex: 'hotel',
            key: 'hotel',
            align: "center",
            width: 200,
            render: (text, record, index) => {
                if (index === 4) {
                    return {
                        props: {
                            colSpan: 0
                        }
                    }
                }
                const props = {
                    text, index: index > 4 ? index - 1 : index, type: 'number', name: "hotel",
                    compared: {
                        title: ['Hotel Performance Data<br /> 本酒店数据'],
                        record,
                        sqlName: "effect_budget"
                    }, totalIndex: TOTALINDEX
                };

                return <TableText data={{ ...props }} />
            }
        }];
        const dataSource = JSON.parse(JSON.stringify(toJS(budget)));
        dataSource.splice(4, 0, {
            name: "",
            interval: 0,
            area: 0,
            hotel: 0,
            sort: 0,
        });
        return (
            <Spin spinning={loading}>
                <div className="table7_1_1 style-center">
                    <Row className="title" id="table6_2"  >
                        <Row>1.1.2 Budget {date} 年预算坪效
                        <span style={{ float: "right", fontSize: 16 }}>
                                RMB/Per SQM(Seat)
                            <br />
                                元/平米（位）
                        </span>
                        </Row>
                        <Table
                            columns={columns}
                            dataSource={dataSource}
                            size="middle"
                            bordered
                            id="table2"
                            pagination={false}
                            className="content"
                            rowKey={(record, index) => index}
                        />
                    </Row>
                    <Auth loading={loading} auth="edit_6_2">
                        <Row className="table-footer-btn">
                            <Button
                                type="primary"
                                style={{ marginRight: 10 }}
                                onClick={() => {
                                    this.setState({ print: true }, () => {
                                        this.onExpoetExcel();
                                    });
                                }}
                            >导出Excel</Button>
                        </Row>
                    </Auth>
                </div>
            </Spin >
        );
    }
}

export default index;





// WEBPACK FOOTER //
// ./src/components/table/effect/Budget.js